import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { NavigateFunction } from "react-router-dom";
import {
  CustomLabel,
  FlexContainer,
  InputErrorModel,
  Loader,
  Merediem,
  ModalComponent,
  RedButton,
  SapphireBlueButton,
  TextInputWithDropdown,
  TimeAMPM,
  ToastService,
  UtilityMethods,
  Input,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import DatePicker from "@mindmemobile/mm-date-picker";
import { AuthService } from "../../../shared/services";
import PromotionService from "../../../shared/services/PromotionService";
import { AmountType } from "../../../shared/enums/Promotion.enum";
import { PromotionModel } from "../../../shared/models/PromotionModels";
import { firstValueFrom } from "rxjs";
import { AccountSettingsStore } from "../../../shared/store";
import { NavPills } from "../../../shared/components";
import { DescriptionCell, LabelCell } from "../../../shared/styles";
import styled from "styled-components";
import { InputWrapper } from "../../../shared/components/TableGrid";

type IProps = {
  navigate: NavigateFunction;
  isEdit?: boolean;
  promotionId?: string;
  isActive?: boolean;
  onClose: (refresh: boolean, promotionId?: string) => void;
};

export const PromotionWrapper = styled(FlexContainer)`
  flex-direction: column;
  .styled-input.merchant-inputs {
    width: 250px;
    &.promo-name-input {
      width: 400px;
    }
    &.amount-max-input {
      width: 160px;
      margin-left: 20px;
    }
    &.promo-datepicker {
      &:not(input) {
        width: 200px !important;
        padding: 0px;
        border: none;
      }
      &:focus {
        outline: none;
      }
      & input.error-border {
        border: none !important;
      }
      input.promo-datepicker {
        &:focus {
          outline: none !important;
          box-shadow: none !important;
        }
      }
      & + .datepicker-overlay-container {
        top: unset !important;
        bottom: 0 !important;
        transform: translate(-2px, -44px);
        .popover-arrow {
          bottom: 0 !important;
          top: unset !important;
          transform: translate(-38%, 8px) !important;
          &::before {
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-top: 7px solid #0000002d;
            border-bottom: none;
          }
          &::after {
            border-left: 8px solid transparent;
            border-right: 7px solid transparent;
            border-top: 5px solid #fff;
            border-bottom: none;
            top: -1px;
          }
        }
      }
    }
  }
  .promo-text-dpdn {
    padding: 8px 10px;
    justify-content: space-between;
    width: 250px !important;
    .header {
      padding: 0px;
    }
    .select-header-span {
      padding: 0px 0px 0px 6px;
    }
    .text-input {
      width: 80px !important;
    }
    .dropdown-input .options-menu {
      transform: translate(3px, 35px);
      width: 105px;
    }
    &.promo-time-input {
      width: 160px !important;
      gap: 8px;
      .text-input {
        min-width: 40px;
        width: 48px !important;
      }
      .dropdown-input .options-menu {
        width: 80px;
      }
    }
  }

  .max-usage-input {
    width: 70px !important;
  }
  /* .min-amount-input {
    width: 200px !important;
  } */
  .dollar-usd-input {
    .input-wrapper {
      position: relative;
      &::after {
        content: "USD";
        position: absolute;
        top: 50%;
        right: 12px;
        transform: translateY(-50%);
        font-size: 16px;
        color: #aaa;
      }
      &::before {
        content: "$";
        position: absolute;
        top: 50%;
        left: 12px;
        transform: translateY(-50%);
        font-size: 18px;
        color: #555;
      }
    }
    &.usd-with-error {
      .input-wrapper {
        &::after {
          top: 19px;
        }
        &::before {
          top: 19px;
        }
      }
    }
    input[type="number"] {
      width: 200px;
      padding-left: 30px;
      padding-right: 45px;
    }
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
  .dollar-input {
    width: 250px;
    .input-wrapper {
      position: relative;
      &::before {
        content: "$";
        position: absolute;
        top: 50%;
        left: 12px;
        transform: translateY(-50%);
        font-size: 18px;
        color: #555;
      }
    }
    input[type="text"] {
      width: 120px;
      padding-left: 30px;
      padding-right: 15px;
    }
    &.maximum-dollar-input {
      width: 180px;
      input.amount-max-input {
        width: 120px;
        padding-left: 30px;
        padding-right: 15px;
      }
      .input-wrapper {
        position: relative;
        &::before {
          content: "$";
          position: absolute;
          top: 50%;
          left: 30px;
          transform: translateY(-50%);
          font-size: 18px;
          color: #555;
        }
      }
    }
  }
  .percent-input {
    width: 250px;
    .input-wrapper {
      position: relative;
      &::after {
        content: "%";
        position: absolute;
        top: 0px;
        right: 12px;
        /* transform: translateY(-50%); */
        font-size: 16px;
        color: #555;
        font-weight: 400;
      }
    }
    input[type="text"] {
      padding-left: 10px;
      padding-right: 35px;
      width: 85px !important;
    }
  }
`;

const NewPromotionPopUp: React.FC<IProps> = ({
  onClose,
  isEdit = false,
  promotionId,
  navigate,
  isActive,
}) => {
  const [activeNavPill, setActiveNavPill] = useState<"discount" | "limits">(
    "discount"
  );
  const [isAPIRequestPending, setAPIRequestPending] = React.useState(false);
  const [data, setData] = useState<PromotionModel>(new PromotionModel());
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (isEdit) {
      loadPromotionData();
    }
  }, [isEdit]);

  const loadPromotionData = async () => {
    if (isEdit) {
      setLoader(true);
      const response = await firstValueFrom(
        PromotionService.getPromotionData(
          AuthService.authData.accountId,
          promotionId || ""
        )
      );
      if (response?.result) {
        const data = PromotionModel.deserializeAPIModel(response.result);
        setData(data);
        setLoader(false);
      } else {
        ToastService.showError("Error in getting promotion details");
      }
    }
    setLoader(false);
  };

  function row(label: string, rightSide: React.ReactNode, className?: string) {
    return (
      <FlexContainer spacing={10} alignItems="center" className={className}>
        <LabelCell>
          <CustomLabel>{label}</CustomLabel>
        </LabelCell>
        <DescriptionCell>
          <FlexContainer alignItems="center" spacing={20}>
            {rightSide}
          </FlexContainer>
        </DescriptionCell>
      </FlexContainer>
    );
  }

  const formatAmount = (value: string): string => {
    return AccountSettingsStore.formatAmount(
      parseFloat(value.toString() || "0.00"),
      true
    );
  };

  const handleInputChange = (
    field: keyof PromotionModel,
    value: string | number | boolean | Date,
    isBlur?: boolean
  ) => {
    const clonedData = new PromotionModel({ ...data });
    switch (field) {
      case "name":
        clonedData.name = value as string;
        break;
      case "promoCode":
        clonedData.promoCode = value as string;
        break;
      case "amount":
        if (isBlur) {
          value = formatAmount(value.toString());
        }
        clonedData.amount = value as number;
        break;
      case "amountType":
        clonedData.amountType = value as keyof typeof AmountType;
        break;
      case "freeShipping":
        clonedData.freeShipping = value as boolean;
        break;
      case "waiveSurcharge":
        clonedData.waiveSurcharge = value as boolean;
        break;
      case "minimumPurchase":
        if (isBlur && (value as number) > 0) {
          value = formatAmount(value.toString());
        }
        clonedData.minimumPurchase = value as number;
        break;
      case "totalUsage":
        clonedData.totalUsage = value as number;
        break;
      case "beginsDate":
        clonedData.beginsDate = value as Date;
        break;
      case "beginsTime":
        clonedData.beginsTime = value as string;
        break;
      case "beginsMeredium":
        clonedData.beginsMeredium = value as keyof typeof Merediem;
        break;
      case "endsDate":
        clonedData.endsDate = value as Date;
        break;
      case "endsTime":
        clonedData.endsTime = value as string;
        break;
      case "endsMeredium":
        clonedData.endsMeredium = value as keyof typeof Merediem;
        break;
      case "maximumAmount":
        if (isBlur) {
          value = formatAmount(value.toString());
        }
        clonedData.maximumAmount = value as number;
        break;
      default:
        break;
    }
    setData(new PromotionModel({ ...clonedData }));
  };

  const textInput = (
    field: keyof PromotionModel,
    type: string,
    value: string | Date,
    className: string,
    error: boolean,
    placeholder: string,
    maxLength?: number
  ) => {
    return (
      <Input
        type={type as "text" | "textarea" | "number" | "date"}
        value={value}
        error={error}
        errorMessage={""}
        maxLength={maxLength}
        className={`styled-input merchant-inputs ${className}`}
        onChange={(e, isBlur) =>
          handleInputChange(field, e.target.value, isBlur)
        }
        placeholder={placeholder}
        onDateChangeWithNull={(date) =>
          handleInputChange(field, date ? new Date(date) : "")
        }
        shouldEmptyDate={true}
      />
    );
  };

  const checkBoxInput = (
    key: keyof PromotionModel,
    value: boolean,
    label: string,
    disabled: boolean
  ) => {
    return (
      <Input
        type="checkbox"
        value={value}
        onChange={(e) => handleInputChange(key, e.target.checked)}
        label={label}
        disabled={disabled || false}
      />
    );
  };

  function updateTime(
    amPm: keyof typeof TimeAMPM,
    time: string,
    isBlur: boolean,
    isEnd?: boolean
  ) {
    if (time) {
      time = time.replace(/[^0-9:]/g, ""); // Remove non-digits and colons
      if (isBlur) {
        const match = time.match(/(\d{1,2}):(\d{1,2})/);
        if (match) {
          let [_, hours, minutes] = match;
          // Ensure hours and minutes are zero-padded
          hours = hours.padStart(2, "0");
          minutes = minutes.padStart(2, "0");

          // Return the formatted time string
          time = `${hours}:${minutes}`;
        }
      }
    }
    setData(
      (prevData) =>
        new PromotionModel({
          ...prevData,
          beginsMeredium: isEnd ? data.beginsMeredium : amPm,
          beginsTime: isEnd ? data.beginsTime : time,
          endsMeredium: isEnd ? amPm : data.endsMeredium,
          endsTime: isEnd ? time : data.endsTime,
        })
    );
  }

  const discountContent = () => {
    return (
      <FlexContainer fxLayout="column" spacing={20} padding="20px 0px 0px">
        {row(
          "Name",
          <>
            {textInput(
              "name",
              "text",
              data.name,
              "promo-name-input",
              data.hasError("name"),
              ""
            )}
          </>
        )}
        {row(
          "Promo Code",
          <>
            {textInput(
              "promoCode",
              "text",
              data.promoCode,
              "",
              data.hasError("promoCode"),
              ""
            )}
          </>
        )}
        {row(
          "Amount",
          <FlexContainer alignItems="center" spacing={30}>
            <div>
              <FlexContainer
                className={
                  data.amountType === "Percentage"
                    ? "percent-input"
                    : "dollar-input"
                }
              >
                <TextInputWithDropdown
                  textInputValue={data.amount.toString()}
                  dropdownValue={data.amountType}
                  onTextChange={(value, isBlur) =>
                    handleInputChange("amount", value, isBlur)
                  }
                  onDropdownChange={(option) =>
                    handleInputChange("amountType", option.value, false)
                  }
                  className="promo-text-dpdn"
                  dropdownOptions={[
                    Object.keys(AmountType).map((key) => ({
                      value: key,
                      label: AmountType[key as keyof typeof AmountType],
                    })),
                  ]}
                  error={data.hasError("amount")}
                />
              </FlexContainer>
            </div>
            {data.amountType === "Percentage" && (
              <FlexContainer alignItems="center">
                <div>
                  <CustomLabel>Maximum</CustomLabel>
                </div>
                <div>
                  <FlexContainer className="dollar-input maximum-dollar-input">
                    {textInput(
                      "maximumAmount",
                      "number",
                      data.maximumAmount.toString(),
                      "amount-max-input",
                      data.hasError("maximumAmount"),
                      ""
                    )}
                  </FlexContainer>
                </div>
              </FlexContainer>
            )}
          </FlexContainer>
        )}
        {/* {row(
          "Shipping",
          checkBoxInput(
            "freeShipping",
            data.freeShipping,
            "Free Shipping",
            false
          )
        )} */}
        {row(
          "Waive Surcharge",
          checkBoxInput(
            "waiveSurcharge",
            data.waiveSurcharge,
            "Waive Surcharge",
            false
          )
        )}
      </FlexContainer>
    );
  };

  const limitsContent = () => {
    return (
      <FlexContainer fxLayout="column" spacing={20}>
        <CustomLabel
          textAlign="center"
          className="full-width"
          margin="5px 0px 20px"
        >
          Add restrictions to limit when this Promotion can be used.
        </CustomLabel>
        {row(
          "Minimum Purchase",
          <FlexContainer
            spacing={15}
            fxLayout="row"
            className="dollar-usd-input"
          >
            <div>
              <FlexContainer spacing={15} alignItems="center">
                {textInput(
                  "minimumPurchase",
                  "number",
                  data.minimumPurchase?.toString() || "",
                  "min-amount-input",
                  data.hasError("minimumPurchase"),
                  ""
                )}
                <CustomLabel>
                  Total purchase amount (including add-ons)
                </CustomLabel>
              </FlexContainer>
            </div>
          </FlexContainer>
        )}
        {row(
          "Maximum Usage",
          <div>
            <FlexContainer spacing={15} alignItems="center">
              {textInput(
                "totalUsage",
                "number",
                data.totalUsage?.toString() || "",
                "max-usage-input",
                data.hasError("totalUsage"),
                ""
              )}
              <CustomLabel>total times</CustomLabel>
            </FlexContainer>
          </div>
        )}
        <FlexContainer alignItems="center" spacing={10}>
          <LabelCell>
            <CustomLabel>Begins</CustomLabel>
          </LabelCell>
          <DescriptionCell>
            <FlexContainer alignItems="center" spacing={15}>
              {textInput(
                "beginsDate",
                "date",
                data.beginsDate
                  ? UtilityMethods.toLocalISOString(data.beginsDate)
                  : "",
                "invoice-payment-datepicker promo-datepicker",
                data.hasError("beginsDate"),
                ""
              )}
              {data.beginsDate && (
                <>
                  <TextInputWithDropdown
                    textInputValue={data.beginsTime}
                    dropdownValue={data.beginsMeredium}
                    onTextChange={(value, isBlur) =>
                      updateTime(data.beginsMeredium, value, isBlur, false)
                    }
                    onDropdownChange={(option) =>
                      updateTime(option.value, data.beginsTime, false, false)
                    }
                    className="promo-text-dpdn promo-time-input"
                    dropdownOptions={[
                      Object.keys(TimeAMPM).map((key) => ({
                        value: key,
                        label: TimeAMPM[key as keyof typeof TimeAMPM],
                      })),
                    ]}
                    error={data.hasError("beginsTime")}
                    placeholderForTextInput="hh:mm"
                    isTime={true}
                  />
                  <FlexContainer alignItems="center">
                    <CustomLabel>
                      {AccountSettingsStore.generalSettings.timeZone
                        .abbreviation || ""}
                    </CustomLabel>
                  </FlexContainer>
                </>
              )}
            </FlexContainer>
          </DescriptionCell>
        </FlexContainer>
        <FlexContainer alignItems="center" spacing={10}>
          <LabelCell>
            <CustomLabel>Ends</CustomLabel>
          </LabelCell>
          <DescriptionCell>
            <FlexContainer alignItems="center" spacing={15}>
              {textInput(
                "endsDate",
                "date",
                data.endsDate
                  ? UtilityMethods.toLocalISOString(data.endsDate)
                  : "",
                "invoice-payment-datepicker promo-datepicker",
                data.hasError("endsDate"),
                ""
              )}
              {data.endsDate && (
                <>
                  <TextInputWithDropdown
                    textInputValue={data.endsTime}
                    dropdownValue={data.endsMeredium}
                    onTextChange={(value, isBlur) =>
                      updateTime(data.endsMeredium, value, isBlur, true)
                    }
                    onDropdownChange={(option) =>
                      updateTime(option.value, data.endsTime, false, true)
                    }
                    className="promo-text-dpdn promo-time-input"
                    dropdownOptions={[
                      Object.keys(TimeAMPM).map((key) => ({
                        value: key,
                        label: TimeAMPM[key as keyof typeof TimeAMPM],
                      })),
                    ]}
                    error={data.hasError("endsTime")}
                    placeholderForTextInput="hh:mm"
                    isTime={true}
                  />
                  <FlexContainer alignItems="center">
                    <CustomLabel>
                      {AccountSettingsStore.generalSettings.timeZone
                        .abbreviation || ""}
                    </CustomLabel>
                  </FlexContainer>
                </>
              )}
            </FlexContainer>
          </DescriptionCell>
        </FlexContainer>
        <CustomLabel fontSize={"12px"}>
          Valid dates are United States East Coast (GMT - 4) timezone. Change in
          Settings.
        </CustomLabel>
      </FlexContainer>
    );
  };

  const navPills = () => {
    return (
      <FlexContainer
        alignItems="center"
        padding="0px 0px 40px"
        className="pl-navpills"
      >
        <div className="flex-auto-grow">
          <NavPills
            defaultActiveKey="discount"
            activeKey={activeNavPill}
            pills={[
              {
                key: "discount",
                title: "DISCOUNT",
              },
              {
                key: "limits",
                title: "LIMITS",
              },
            ]}
            onSelect={(key) => setActiveNavPill(key as "discount" | "limits")}
          />
        </div>
      </FlexContainer>
    );
  };

  const body = () => {
    return (
      <PromotionWrapper>
        {navPills()}
        {activeNavPill === "discount" && discountContent()}
        {activeNavPill === "limits" && limitsContent()}
      </PromotionWrapper>
    );
  };

  const onClickSave = () => {
    if (isAPIRequestPending) return;

    setAPIRequestPending(true);
    const isValidated = data.validate();

    if (!isValidated) {
      if (!data.hasErrorInDiscountSection()) {
        setActiveNavPill("limits");
      } else {
        setActiveNavPill("discount");
      }
      setAPIRequestPending(false);
      setData((prevData) => new PromotionModel({ ...prevData, ...data }));
      return;
    }

    const apiModelToCheckUniquePromoCode = data.createAPIModelToTestUniqueness(
      promotionId || ""
    );

    const apiModelForUpdate = data.createAPIModelForUpdate(
      isActive,
      promotionId || ""
    );
    const apiModelForCreate = data.createAPIModel();
    PromotionService.checkCodeUniqueness(
      apiModelToCheckUniquePromoCode
    ).subscribe({
      next: (response) => {
        if (!response.result) {
          ToastService.showError(
            "Promo code already exists. Please enter a different one."
          );
          const clonedData = new PromotionModel({ ...data });
          clonedData.errors.push({
            field: "promoCode",
            message: "Promo code already exists.",
          });
          setData(clonedData);
          setAPIRequestPending(false);
          return;
        }
        if (isEdit) {
          PromotionService.updatePromotion(apiModelForUpdate).subscribe({
            next: (response) => {
              if (response.result) {
                onClose(true);
                ToastService.showSuccess("Promotion updated successfully");
              } else {
                ToastService.showError("Error in updating Promotion");
              }
              setAPIRequestPending(false);
            },
            error: () => {
              setAPIRequestPending(false);
              ToastService.showError("Error in updating Promotion");
            },
          });
          return;
        }
        PromotionService.createPromotion(apiModelForCreate).subscribe({
          next: (response) => {
            if (response.result) {
              onClose(true, response.result);
              ToastService.showSuccess("Promotion created successfully");
            } else {
              ToastService.showError("Error in creating Promotion");
            }
            setAPIRequestPending(false);
          },
          error: () => {
            setAPIRequestPending(false);
            ToastService.showError("Error in creating Promotion");
          },
        });
      },
      error: () => {
        setAPIRequestPending(false);
        ToastService.showError("Error in checking promotion code uniqueness");
      },
    });
  };

  return (
    <ModalComponent
      title={isEdit ? "Update Promotion" : "New Promotion"}
      titleFontSize="22px"
      bodyPadding="40px 90px 40px 60px"
      onClose={() => onClose && onClose(false)}
      showFooter={true}
      wrapperWidth="900px"
      bodyHeight="495px"
      bodyBackgroundColor="#fff"
      footerHeight="auto"
      footerBackground="#F4F7FB"
      footerContent={
        <FlexContainer alignItems="center" justifyContent="center" spacing={15}>
          <RedButton
            minWidth="120px"
            height="40px"
            onClick={() => onClose(false)}
          >
            Cancel
          </RedButton>
          <SapphireBlueButton
            primary
            disabled={isAPIRequestPending}
            minWidth="120px"
            height="40px"
            onClick={() => onClickSave()}
          >
            {isEdit ? "Update" : "Add"}
          </SapphireBlueButton>
        </FlexContainer>
      }
    >
      {loader ? new Loader(true, "", "380px").loaderComponent : body()}
    </ModalComponent>
  );
};

export default withRouter(observer(NewPromotionPopUp));
